import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { OrderApiConfiguration } from '../../order-and-billing/order-api-configuration';

import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { PatientNetwork } from 'app/shared/models/orders-and-billing/patient-network';

@Injectable()
export class PatientNetworkService extends ServiceBase {
    private _actionUrl: string;
    private _url: string;
    private _getByPatientId: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this._actionUrl = _configuration.server;
        this._url = this._actionUrl + _configuration.patientSelfPay.url;
        this._getByPatientId = this._actionUrl + _configuration.patientSelfPay.getByPatientId;
    }

    getAll = (): Observable<any> => {
        return this._http.get<any>(this._url);
    }

    public getByPatientId = (patientId: number): Observable<PatientNetwork[]> => {
        return this._http.get<any>(this._getByPatientId + patientId);
    }

    public insert = (patientNetwork: PatientNetwork): Observable<any> => {
        return this._http.post<any>(this._url, JSON.stringify(patientNetwork));
    }

    public update = (patientNetwork: PatientNetwork): Observable<any> => {
        return this._http.put<any>(this._url, JSON.stringify(patientNetwork));
    }
}